var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-card",style:({ backgroundColor: _vm.bgColor })},[_c('div',{staticClass:"stat-header"},[_c('span',{staticClass:"stat-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"stat-number",style:({ fontSize: _vm.fontSize })},[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }